"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAppFailure = exports.fetchAppSuccess = exports.fetchAppRequest = exports.setDomain = exports.setAppId = exports.FETCH_APP_FAILURE = exports.FETCH_APP_SUCCESS = exports.FETCH_APP_REQUEST = exports.SET_DOMAIN = exports.SET_APP_ID = void 0;
exports.SET_APP_ID = 'app/SET_APP_ID';
exports.SET_DOMAIN = 'app/SET_DOMAIN';
exports.FETCH_APP_REQUEST = 'app/FETCH_APP_REQUEST';
exports.FETCH_APP_SUCCESS = 'app/FETCH_APP_SUCCESS';
exports.FETCH_APP_FAILURE = 'app/FETCH_APP_FAILURE';
var setAppId = function (id) { return ({ type: exports.SET_APP_ID, id: id }); };
exports.setAppId = setAppId;
var setDomain = function (domain) { return ({ type: exports.SET_DOMAIN, domain: domain }); };
exports.setDomain = setDomain;
var fetchAppRequest = function () { return ({ type: exports.FETCH_APP_REQUEST }); };
exports.fetchAppRequest = fetchAppRequest;
var fetchAppSuccess = function (data) { return ({ type: exports.FETCH_APP_SUCCESS, data: data }); };
exports.fetchAppSuccess = fetchAppSuccess;
var fetchAppFailure = function (e) { return ({ type: exports.FETCH_APP_FAILURE, e: e }); };
exports.fetchAppFailure = fetchAppFailure;
